export const getEmail = (state) => {
    return state.emailVerifyInput.email;
};

export const emailVerified = (state) => {
    return state.emailVerifyInput.emailVerified;
};

export const emailVerifyAttempted = (state) => {
    return state.emailVerifyInput.emailVerifyAttempted;
};

export const getInputErrorState = (state) => {
    return state.emailVerifyInput.inputErrorState;
};
